import type { RawKeyedArrow } from 'chessboard/plugins/arrows/config/types';
import { Arrows, ArrowType } from 'chessboard/plugins/arrows/config/types';
import { createArrowsEventHandlers } from 'chessboard/plugins/arrows/event-handlers';
import type { Plugins } from 'chessboard/core/plugins/config/types';
import type { Core } from 'chessboard/core/config/types';
import { init } from 'chessboard/plugins/arrows/event-handlers/init';
import type { Markings } from 'chessboard/plugins/markings/config/types';
import { createKeyedArrow } from 'chessboard/plugins/arrows/model/create-keyed-arrow';

/**
 * Creates the arrows plugin.
 */
export function createArrowsPlugin(): Plugins.Model {
  return {
    match: createArrowsEventHandlers(),
    name: Arrows.Plugin.Name,
    create: init,
    destroy,
  };

  /**
   * clean up arrows when removing plugin
   */
  function destroy(context: Core.Context) {
    const { api, renderer, options } = context;
    if (!api.markings) {
      return;
    }
    const markingsApi = <Markings.API>api.markings;

    const currentRawArrows = <RawKeyedArrow[]>markingsApi.getAllWhere({ types: [ArrowType] });
    const currentArrows = currentRawArrows.map((rawArrow) =>
      createKeyedArrow({ rawArrow, options }),
    );
    renderer?.removeArrows(currentArrows, context);
  }
}
